import {Rive} from "@rive-app/canvas";

document.addEventListener("DOMContentLoaded", () => {
	initLoader();
	checkUrl();
});

function initLoader() {
	let loader = document.querySelector("#partners-loader");
	if (!loader) return;
	const r = new Rive({
		src: wp_helper.home_path + "/src/partner-loader.riv",
		canvas: loader,
		autoplay: true,
	});
}

function checkUrl() {
	let buttons = document.querySelectorAll(".btn-external-link");
	if (!buttons.length) return;

	buttons.forEach(el => {
		el.addEventListener("click", e => {
			e.preventDefault();
			let href = e.target.getAttribute("href");
			let timeout = 3000;
			document.body.classList.add("loader-visible");
			setTimeout(() => {
				window.open(href, "_blank");
			}, timeout);
		});
	});

	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState) {
			document.body.classList.remove("loader-visible");
		}
	});
}
